import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";

/**
 * Supabase sends reset links to the Site URL when the requested redirect isn't
 * allowed, so the user can land on any page. Send them to the "set a new
 * password" form wherever they arrive.
 */
export function PasswordRecoveryRedirect() {
  const { isPasswordRecovery } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPasswordRecovery && pathname !== "/auth") {
      navigate("/auth?reset=true", { replace: true });
    }
  }, [isPasswordRecovery, pathname, navigate]);

  return null;
}
